import type { IdentifyTraits } from '@/composables/useAnalytics'
import type { Mixpanel } from '@/plugins/mixpanel'
import { PHOENIX_EVENT_CONTEXT } from './phoenixContext'

/** Sets Mixpanel distinct id and People profile — matches legacy Lyka email lookup in Users. */
export const identifyMixpanelUser = (mixpanel: Mixpanel, traits: IdentifyTraits): void => {
  mixpanel.identify(traits.cognito_user_id)
  mixpanel.people.set({
    $email: traits.email,
    $first_name: traits.first_name,
    $last_name: traits.last_name,
    $phone: traits.phone,
    ...PHOENIX_EVENT_CONTEXT,
    tenant: traits.tenant,
    cognito_user_id: traits.cognito_user_id,
  })
}
